let storage = require('./storage.js');
let utils = require('./utils.js');
let language = require('./locale/language.js');
let stropheConnection = require('./stropheConnection.js');
let recentdesign = require('./recentdesign.js');
const webEncrypt  = require('./webchatEncryptDecrypt.js');

let shouldHandleScroll;

module.exports = {
    getOnCallsParams: function(siteId,search,page,type,unitName){
        let params; 
        if(siteId == null || siteId == "" || siteId.length == 0) {
            params = '?search=' + search + '&page=' + page + '&size=' + language.locali().default_size_pagination;
        } else {
            let unitParam = (unitName != '') ? '&unit='+unitName : '';
            if(typeof type != 'undefined' && type != ''){
                params = '?siteId=' + siteId + '&search=' + search + '&page=' + page + '&size=' + language.locali().default_size_pagination + '&sortby=' + type+unitParam;

            }else {
                params = '?siteId=' + siteId + '&search=' + search + '&page=' + page + '&size=' + language.locali().default_size_pagination+unitParam;

            }
        }

        return params;
    },
    getOnCallsEmptyCheck(isEmpty,elementId){
        if (isEmpty == 1) 
            $(elementId).empty();
    },
    getOnCallsActiveMembObj: function(activeMemberName,activeMemberId,userLoggedIn){
        let activeMemberColorName;
        if(activeMemberName == "") {
            activeMemberColorName = "#999";
        } else if (activeMemberName != "" && activeMemberId === userLoggedIn) {
            activeMemberColorName = "#42AB14";
            activeMemberName = "You";
        } else {
            activeMemberColorName = "#454545";
        }

        let activeMembObj = {
            activeMemberName    :   activeMemberName,
            activeMemberColorName   :   activeMemberColorName
        }

        return activeMembObj;
    },
    getOnCallsIconixBadgeIcon(activeMemberName,isChatUser){
        let IconixBadgeIcon = '';
        if(activeMemberName != "") {
            if(isChatUser){
                IconixBadgeIcon = '<img class="contact-image fave_icone" src="./src/images/svg/ikonixicon.svg">'
            }
        }

        return IconixBadgeIcon;
    },
    getOnCallsMsgPagerNo: function(values){
        let msg_pager_no = (values.activeMemberDetails != null) ? values.activeMemberDetails.pagerNumber : "";
        return msg_pager_no;
    },
    getOnCallsSharedConditionCheck: function(values,activeMemberId,oncall_pager_no,msg_pager_no,profileVisibility,userLoggedIn){
        let isCheck;
        if((values.onCallReceiveDeviceId || (activeMemberId != "" && values.isActive) || (oncall_pager_no != "" || (msg_pager_no != "" && profileVisibility.pager_number)) && activeMemberId !== userLoggedIn )){
             isCheck = true;
        }else {
            isCheck = false;

        }

        return isCheck
    },
    getOnCallsSharedDevUserChatEl: function(values){
        let sharedDeviceUserChatEl;
        if(values.isChatUser == 1){

            sharedDeviceUserChatEl = '<li role="presentation"><a class="sharedDeviceUserChat" data-member="'+values.activeMemberId+'" data-chat-user="'+values.isChatUser+'"><img src="./src/images/svg/ikonixicon.svg" alt="" class="SharedDeviceIconImg">Connect Chat</a></li>';
        }else {
            sharedDeviceUserChatEl = ""
        }

        return sharedDeviceUserChatEl;
    },
    getOnCallsSharedDevListEl: function(values,activeMemberId,sharedDeviceUserChatEl,sharedDeviceRoleEl){
        let sharedDeviceListEl;
        if(values.onCallReceiveDeviceId && (activeMemberId != "" && activeMemberId != "null")){

            sharedDeviceListEl = sharedDeviceUserChatEl + sharedDeviceRoleEl;

        }else if((activeMemberId != "" && activeMemberId != "null")) {

            sharedDeviceListEl = sharedDeviceUserChatEl;

        }else if(values.onCallReceiveDeviceId) {

            sharedDeviceListEl =  sharedDeviceRoleEl;

        }else {
            sharedDeviceListEl = "";
        }

        return sharedDeviceListEl;
    },
    getOnCallsSharedDevOncallPagerNo: function(values,oncall_pager_no,pagerIconEl,sharedDeviceListEl){
        let oncall_pager_el;
        if(oncall_pager_no !=""){
            oncall_pager_el = '<li role="presentation"><a class="msg-role-pager" data-name="'+values.onCallName+'" data-pagerNo = "'+oncall_pager_no+'" data-nodeId="'+values.nodeId+'" data-type="Pager" data-toid="'+values.onCallId+'">'+pagerIconEl+ ' Message Role Pager</a></li>'

            sharedDeviceListEl += oncall_pager_el;
        }

        return sharedDeviceListEl;
    },
    getOnCallsSharedDevMsgEl: function(values,activeMemberId,msg_pager_no,userLoggedIn){
        let oncall_pager_no = values.onCallPagerNumber; 
        let sharedDeviceMsgEl;
        let pagerIconEl = '<img src="./src/images/pager.svg" class="SharedDeviceIconImg"/>';

        let pagerEl = "";
        let profileVisibility = webEncrypt.getFromLocalStorageAndDecrypt('settings').profileVisibility;
        let msg_pager_el;
        
        let isCheck = module.exports.getOnCallsSharedConditionCheck(values,activeMemberId,oncall_pager_no,msg_pager_no,profileVisibility,userLoggedIn);

        if(isCheck){
            let SharedDevClass = (pagerEl == "") ? "sharedMsgIconMove" : "";

            let sharedDeviceUserChatEl = module.exports.getOnCallsSharedDevUserChatEl(values);

            let sharedDeviceRoleEl = '<li role="presentation"><a class="msg-received-device-pager" data-deviceName ="'+values.onCallReceiveDeviceName+'" data-pagerNo = "'+values.onCallReceiveDeviceId+'" data-nodeid="'+values.nodeId+'" data-type="ReceiveDevice" data-toid="'+values.onCallId+'"><img src="./src/images/svg/message.svg" alt="" class="SharedDeviceIconImg">Message '+values.onCallReceiveDeviceName+'</a></li>'

            let sharedDeviceListEl = module.exports.getOnCallsSharedDevListEl(values,activeMemberId,sharedDeviceUserChatEl,sharedDeviceRoleEl);

            sharedDeviceListEl = module.exports.getOnCallsSharedDevOncallPagerNo(values,oncall_pager_no,pagerIconEl,sharedDeviceListEl);

            if(msg_pager_no !="" && profileVisibility.pager_number){
                msg_pager_el = '<li role="presentation"><a href="javascript:void(0);" class="msg-pager" data-name="'+values.activeMemberName+'" data-pagerNo = "'+msg_pager_no+'" data-nodeId="'+values.activeMemberDetails.nodeId+'" data-type="Pager" data-toid="'+values.activeMemberId+'" >'+pagerIconEl+' Message Pager</a></li>'
                sharedDeviceListEl += msg_pager_el;
            }
            

            if(sharedDeviceListEl != ""){
                sharedDeviceMsgEl = '<div class="dropdown sharedDevMsgDiv  '+SharedDevClass+' " ><a class="dropdown-toggle" id="menu1" type="button" data-toggle="dropdown"><svg class="sharedDeviceMsgIcon" data-onCallReceiveDeviceName = "'+values.onCallReceiveDeviceName+'" data-onCallReceiveDeviceId = "'+values.onCallReceiveDeviceId+'" data-member="'+values.activeMemberId+'" data-chat-user="'+values.isChatUser+'" data-isactive="'+values.isActive+'" data-nodeId="'+values.nodeId+'"  data-oncallName="'+values.onCallName+'" data-name="'+values.activeMemberName+'" data-oncall_pager_no="'+oncall_pager_no+'" data-msg_pager_no = "'+msg_pager_no+'" data-activeMemberId="'+values.activeMemberId+'"  xmlns="http://www.w3.org/2000/svg" id="Layer_1" data-name="Layer 1" viewBox="0 0 20 20"><defs><style>.cls-1{fill:#f09343;}</style></defs><title></title><path class="cls-1" d="M5.83,10.66a.69.69,0,0,1-.51-.21.71.71,0,0,1-.21-.5.73.73,0,0,1,.71-.72H9.07a.72.72,0,0,1,0,1.43Zm0-.78Z"/><path class="cls-1" d="M5.28,17.41a1,1,0,0,1-.38-.07,1.05,1.05,0,0,1-.66-1V14.17H4a2,2,0,0,1-2-2V5A2,2,0,0,1,4,3H15.66a2,2,0,0,1,2,2v7.14a2,2,0,0,1-2,2H8.83L6,17.09A1,1,0,0,1,5.28,17.41ZM4,4.44A.58.58,0,0,0,3.4,5v7.14a.58.58,0,0,0,.58.58H5a.71.71,0,0,1,.72.71v1.94L8,13a.7.7,0,0,1,.51-.22h7.14a.58.58,0,0,0,.58-.58V5a.58.58,0,0,0-.58-.58Z"/><path class="cls-1" d="M13.71,8.12H5.93a.72.72,0,1,1,0-1.43h7.78a.75.75,0,0,1,.51.21.71.71,0,0,1-.51,1.22Z"/></svg></a><ul class="dropdown-menu contact-menu sharedDeviceUlEl" role="menu" aria-labelledby="menu1">'+sharedDeviceListEl+'</ul></div>'
            }else {
                sharedDeviceMsgEl = "";

            }
            
            }else {
            sharedDeviceMsgEl = "";
            }

            return sharedDeviceMsgEl;
    },
    getOnCallsActiveMemberDiv: function(countOfOnCallMembers,isActive,activeMemberColorName,activeMemberName,sharedDeviceSpanHtml){
        let activeMemberDiv = "";
        if(countOfOnCallMembers != 0 && isActive) {

            if(activeMemberName != "" ) {
                activeMemberDiv += '<div class="sideBar-msg active-member-div"><span class="name-status" title="'+activeMemberName+'" style="color: '+ activeMemberColorName +'">' + activeMemberName + ' </span>'+sharedDeviceSpanHtml+'</div>';
            } else {

                let content = module.exports.getOncallRoleType(isActive);
                activeMemberColorName = module.exports.getOncallActiveMemberColorName(isActive);


                activeMemberDiv += '<div class="sideBar-msg active-member-div"><span class="name-status" style="color: '+ activeMemberColorName +'">'+content+'</span>'+sharedDeviceSpanHtml+'</div>';
            }
        }else {
            let content = module.exports.getOncallRoleType(isActive);
            activeMemberColorName = module.exports.getOncallActiveMemberColorName(isActive);

            activeMemberDiv += '<div class="sideBar-msg active-member-div"><span class="name-status" style="color: '+ activeMemberColorName +'">'+content+'</span>'+sharedDeviceSpanHtml+'</div>';
        }

        return activeMemberDiv;
    },
    getOncallRoleType: function(isActive){
        let content;
        content = isActive ? "Shared Device" : "Role not active";
      
        return content;
    },
      
    getOncallActiveMemberColorName: function(isActive){
    let colorCode;
    colorCode = isActive ? "#454545" : "#999";
    
    return colorCode;
    },
    getOnCallSiteDiv: function(siteName,onCallUnit){
        let siteDiv = "";
        if(siteName != ""){
            onCallUnit = (onCallUnit != null) ? onCallUnit : '';
            siteDiv = '<div class="sideBar-msg site-div"><span class="name-status site-name" title="'+siteName+" " +onCallUnit+'">' + siteName + " "+onCallUnit+ '</span></div>';
        }
    
        return siteDiv;
    },
    getOnCallElementAppend: function(page,elementId,contentDiv,detailsDiv){
        if (page == 1 || page == "") {
            $(elementId).append(contentDiv + detailsDiv);
        } else {
            $(elementId).find('.mCSB_container').append(contentDiv + detailsDiv);
        }
    },
    getOnCallCustomScrollBarset: function(oncallObj,elementId,elementName){
        let search      = oncallObj.search,
            page        = oncallObj.page,
            type        = oncallObj.type,
            unitName    = oncallObj.unitName;
        if (page == 1 || page == "") {
            $(elementId).mCustomScrollbar({
                callbacks: {
                    onTotalScroll: function () {
                        let siteId = $("#currentSiteId").val();
                        if(siteId == 0) {
                            siteId = "";
                        }
                        let rolesCount = $(''+elementId+' .roles-content').length;
                        let rolesLength = rolesCount / language.locali().default_size_pagination;
                        page = rolesLength + 1;
                        if (rolesCount % language.locali().default_size_pagination == 0) {
                            let oncallObj = {
                                siteId      :siteId,
                                search      :search,
                                page        :page,
                                isEmpty     :'',
                                elementName :elementName,
                                type        :type,
                                unitName    :unitName,
                            
                              }
                            module.exports.getOnCalls(oncallObj);
                        }
                    }
                }
            });
        } else {
            $(elementId).mCustomScrollbar("update");
        }
    },
    getOnCallEmptyParticipantCheck: function(rolesLength,elementId){
        if(rolesLength == 0) {
            $(''+elementId+' #noparticipant').remove();
            $(elementId).html("<div id='noparticipant' class='roleNoParticipant'>" + language.locali().noroles_available + "</div>");
        }  
    },
    getOnCallErrorMsgReturn: function(jqXHR,exception){
        let getOnCallErrMsg;
        if (jqXHR.status === 0) {
            getOnCallErrMsg = 'Not connect.\n Verify Network.';
            utils.reconnectionPopupShow();

        } else if (jqXHR.status == 404) {
            getOnCallErrMsg = 'Requested page not found. [404]';
        } else if (jqXHR.status == 500) {
            getOnCallErrMsg = 'Internal Server Error [500].';
        } else if (exception === 'parsererror') {
            getOnCallErrMsg = 'Requested JSON parse failed.';
        } else if (exception === 'timeout') {
            getOnCallErrMsg = 'Time out error.';
        } else if (exception === 'abort') {
            getOnCallErrMsg = 'Ajax request aborted.';
        } else {
            getOnCallErrMsg = 'Uncaught Error.\n' + jqXHR.responseText;
        }

        return getOnCallErrMsg;
    },
    getOnCalls: function (oncallObj) {
        let siteId      = oncallObj.siteId,
            search      = oncallObj.search,
            page        = oncallObj.page,
            isEmpty     = oncallObj.isEmpty,
            elementName = oncallObj.elementName,
            type        = oncallObj.type,
            unitName    = oncallObj.unitName;

    let oncallsUrl = window._env_.ApiURL + "/onCalls/";
    let elementId =  "#"+elementName;
    let params;
    $("#currentSiteId").val(siteId)
     params = module.exports.getOnCallsParams(siteId,search,page,type,unitName);
        $.ajax({
            url: oncallsUrl + params,
            type: 'GET',
            dataType: 'json',
            cache: false,
            contentType: false,
            processData: false,
            async: false,
            crossDomain: true,
            headers: {
                'authorization': storage.getuserToken()
            },
            statusCode: {
                401: function (response) {
                    console.log('Security Token Error');
                    let loginUserInfo = webEncrypt.getFromLocalStorageAndDecrypt('loginUserInfo');
                    let username = loginUserInfo[0][0];
                    storage.setSession(username)
                    let oncallObj = {
                        siteId      :siteId,
                        search      :search,
                        page        :page,
                        isEmpty     :isEmpty,
                        elementName :elementName,
                        type        :type,
                        unitName    :unitName,
                    
                      }
                    module.exports.getOnCalls(oncallObj)
                },
                500: function (response) {
                    console.log('Internal Server Error');
                }
            },
            success: function (response) {
                module.exports.getOnCallsEmptyCheck(isEmpty,elementId);

                for (let keys in response.data) {
                    let values = response.data[keys];
                    let onCallImage = values.onCallImage.trim();
                    let onCallForegroundColor = values.onCallForegroundColor.trim();
                    let fillColor = onCallForegroundColor?onCallForegroundColor:"#fff";
                    let onCallUnit = values.onCallUnit
                    let onCallIcon = values.onCallIcon;
                    let Icon;

                    Icon = utils.getOncallIcon(onCallIcon, fillColor, onCallImage);

                    let userLoggedIn = stropheConnection.logininfo.userJID;
                    let activeMemberId = (values.activeMemberId) ? values.activeMemberId.trim() : "";
                    let activeMemberName = values.activeMemberName.trim();
                    let isChatUser = values.isChatUser;
                    let onCallId = values.onCallId.trim();
                    let onCallName = values.onCallName.trim();
                    let siteId = values.siteId;
                    let isActive = values.isActive;

                    let siteDiv = "";
                    let activeMemberDiv = "";
                    let activeMemberColorName = "";
                    let pagerEl = "";


                    let activeMemberObj = module.exports.getOnCallsActiveMembObj(activeMemberName,activeMemberId,userLoggedIn);

                    activeMemberName        =   activeMemberObj.activeMemberName;
                    activeMemberColorName   =   activeMemberObj.activeMemberColorName;

                    let IconixBadgeIcon = module.exports.getOnCallsIconixBadgeIcon(activeMemberName,isChatUser);

                    let contentDiv = '<div class="roles-content row sideBar-body" id="role-' + onCallId + '" data-member="'+activeMemberId+'" data-chat-user="'+isChatUser+'" data-isunregister="'+values.isUnregisteredUser+'" data-isactive="'+isActive+'"><div  class="col-sm-3 col-xs-3 sideBar-avatar"><div class="avatar-icon"><div class="color-code-roles" style="background-color: '+ utils.hexToRgbA(onCallImage) +';">'+Icon+IconixBadgeIcon+'</div></div> </div><div class="col-sm-9 col-xs-9 sideBar-main contact-list-main"><div class="row"><div class="col-sm-12 col-md-12 col-xs-12 sideBar-name contact-name"><div class="contact-list-div"><span class="name-meta oncall-name" title="'+onCallName+'">' + onCallName + '</span></div></div></div>';

                    let siteName = utils.getSiteAbbreviation(siteId);
                

                    let msg_pager_no = module.exports.getOnCallsMsgPagerNo(values);
                    let sharedDeviceMsgEl = module.exports.getOnCallsSharedDevMsgEl(values,activeMemberId,msg_pager_no,userLoggedIn)

                    let sharedDeviceSpanHtml;
                    sharedDeviceSpanHtml = '<span class="sharedDeviceSpanHtml">'+sharedDeviceMsgEl+pagerEl+'</span>';
                
                    let countOfOnCallMembers = values.countOfOnCallMembers;

                    activeMemberDiv = module.exports.getOnCallsActiveMemberDiv(countOfOnCallMembers,isActive,activeMemberColorName,activeMemberName,sharedDeviceSpanHtml);

                    siteDiv = module.exports.getOnCallSiteDiv(siteName,onCallUnit);

                    let detailsDiv = siteDiv + activeMemberDiv +  '</div></div>';
                    
                    module.exports.getOnCallElementAppend(page,elementId,contentDiv,detailsDiv);
                   
                }

                module.exports.getOnCallCustomScrollBarset(oncallObj,elementId,elementName);

                let rolesLength = $(''+elementId+' .roles-content').length;

                module.exports.getOnCallEmptyParticipantCheck(rolesLength,elementId);
                      
            },
            error: function (jqXHR, exception) {
                let getOnCallErrMsg = '';
                getOnCallErrMsg = module.exports.getOnCallErrorMsgReturn(jqXHR,exception)
               
                console.log(getOnCallErrMsg);
            },
            complete: function(){
                $(".sideRoleNavLoader").hide()
                $(".sideRoleListNavLoader").hide()
            }
        });
     
        return true;
    },
   
    getSiteIdforRoleOrGlobalRole: function(sideBarIdName){
        let siteId;
        let locationId = webEncrypt.getFromLocalStorageAndDecrypt('locationId');        
        if(sideBarIdName == 'globalRoleLists'){
            siteId = $('#globalRoleSiteId').val();
        }else {
            if(locationId != null && typeof locationId != "undefined"){
                siteId = locationId.mysite_role;
            }else {
                siteId = $('#siteDetails').text();
            }
        }

        return siteId;
    },
    unitBasedOncallRecordsScrollHandling(rolesCount,siteId,unitName,sideBarIdName,page,searchVal){
        if (rolesCount % language.locali().default_unit_based_roles_pagination == 0) {
            module.exports.getUnitBasedRoles(siteId,unitName,sideBarIdName,page,searchVal);

        }else {
            module.exports.disableScrollHandler();
        }
    },
    /** Oncall Units Append and Scroll bar update **/
    getOnCallUnitsCustomScrollBarset: function(page,elementId,elementName){
        if (page == 1 || page == "") {
            $(elementId).mCustomScrollbar({
                scrollInertia: false,
                callbacks: {
                    whileScrolling: function(){
                       
                        if (!shouldHandleScroll) {// Skip Or Stop Scroll event After Reach Last Element
                            return; // Skip handling the event if the flag is false
                        }

                        let container = $(this);
                        let scrollTop = container.scrollTop(); // Current scroll position

                        let containerTop = container.offset().top;
                        let containerHeight = container.height();

                        let targetElement = $('.acc__title.active').parent().find('.acc__panel').children().last();
                        
                        if(targetElement.length > 0){
                            let elementTop = targetElement.offset().top - containerTop-300;

                            // Calculate the bottom position of the container
                            let scrollBottom = scrollTop + containerHeight;

                            if (scrollBottom >= elementTop) {
                                console.log('Scroll reached target element!!!!!!!');
                                let siteId;
                                let sideBarIdName = elementName;
                                let unitName = $('.acc__title.active').text();

                                let searchVal;
                                if(elementName == 'roles'){
                                    searchVal = $('#rolesText').val()
                                }else{
                                    searchVal = $('#globalRoleSearchTxt').val()
                                }

                                siteId = module.exports.getSiteIdforRoleOrGlobalRole(sideBarIdName)

                                let rolesCount = $('.acc__title.active').parent().find('.acc__panel').children().length;
                                let rolesLength = rolesCount / language.locali().default_unit_based_roles_pagination;
                                page = rolesLength + 1;

                                module.exports.unitBasedOncallRecordsScrollHandling(rolesCount,siteId,unitName,sideBarIdName,page,searchVal);
                                

                                $(elementId).mCustomScrollbar('update')
                                
                                // Perform actions here when scroll reaches the element
                            }
                        }
                    
                    },
                   
                }
            });
        } else {
            $(elementId).mCustomScrollbar("update");
        }
    },
    /** Oncall Units Element Append **/
    getOnCallUnitsElementAppend: function(page,elementId,rolesUnitDiv){
        if (page == 1 || page == "") {
            $(elementId).append(rolesUnitDiv);
        } else {
            $(elementId).find('.mCSB_container').append(rolesUnitDiv);
        }
    },
    /** Get Oncall Units **/
    getOncallUnits: function(siteId,elementName){
        
        let oncallsUrl = window._env_.ApiURL + "/onCalls/units?siteId="+siteId+"";
        let elementId =  "#"+elementName;
        siteId = parseInt(siteId);
        let page = 1;
        $(elementId).empty(); 
      
        $.ajax({
            url: oncallsUrl,
            type: 'GET',
            dataType: 'json',
            cache: false,
            contentType: false,
            processData: false,
            async: false,
            crossDomain: true,
            headers: {
                'authorization': storage.getuserToken()
            },
            statusCode: {
                401: function (response) {
                    console.log('Security Token Error');
                    let loginUserInfo = webEncrypt.getFromLocalStorageAndDecrypt('loginUserInfo');
                    let username = loginUserInfo[0][0];
                    storage.setSession(username)
                    module.exports.getOncallUnits(siteId, elementName)
                },
                500: function (response) {
                    console.log('Internal Server Error');
                }
            },
            success: function (response) {
                let rolesUnitDiv = '';
                if(response.status == 200){
                    $('.mysiteRoleSearchDiv').show();
                   
                    for (let keys in response.data) {
                        let value = response.data[keys];
    
                        rolesUnitDiv += `<div class="role-screen-content">
                                            <div class="acc">
                                                <div class="acc__card">
                                                    <div class="acc__title">`+value+`</div>
                                                    <div class="acc__panel">
                                                    
                                                    </div>
                                                </div>
                                            </div>
                                        </div>`
                    }
    
                    module.exports.getOnCallUnitsElementAppend(page,elementId,rolesUnitDiv);
                    module.exports.getOnCallUnitsCustomScrollBarset(page,elementId,elementName);
                    if(response.data.length == 1){
                        $(elementId).find('.role-screen-content').first().find('.acc__title').trigger('click')
                        module.exports.scrollMoveToActiveStateDiv(elementName)
                    }
             
                }else if(response.status == 204){
                    $('.mysiteRoleSearchDiv').hide();
                    let siteName = $('#profile').find(".profile-address").text();

                    $(''+elementId+' #noparticipant').remove();
                    let el = `<div class='noparticipant-role'>
                                    <i class="role-icon">
                                        <svg xmlns="http://www.w3.org/2000/svg"
                                            width="98"
                                            height="79"
                                            viewBox="0 0 318 279">
                                            <path
                                                fill="#eaf1fd"
                                                stroke="#eaf1fd"
                                                stroke-width="0.3"
                                                d="M293.7,266.23L24.3,266.23A19.43,19.43 0,0 1,4.95 246.83L4.95,78.91A19.35,19.35 0,0 1,24.3 59.56h97.54a4.67,4.67 0,1 1,0 9.34L24.3,68.9A10.01,10.01 0,0 0,14.29 78.91L14.29,246.83a10.04,10.04 0,0 0,10.01 10.01L293.65,256.84a10.04,10.04 0,0 0,10.01 -10.01L303.67,78.91A10.01,10.01 0,0 0,293.65 68.9L200.88,68.9a4.67,4.67 0,0 1,0 -9.34h92.82a19.35,19.35 0,0 1,19.35 19.35L313.05,246.83A19.4,19.4 0,0 1,293.7 266.23Z" />
                                            <path
                                                fill="#eaf1fd"
                                                d="M13.09,64.19h293.93v195.35h-293.93Z" />
                                            <path
                                                fill="#fff"
                                                stroke="#fff"
                                                stroke-width="0.3"
                                                d="M91.84,158.12A28.07,28.07 0,1 1,119.9 130.06,28.1 28.1,0 0,1 91.84,158.12ZM91.84,111.28A18.73,18.73 0,1 0,110.57 130.01,18.75 18.75 0,0,0 91.84,111.28ZM139.93,219.12L43.74,219.12a4.64,4.64 0,0 1,-4.67 -4.67,52.76 52.76 0,1,1 105.53,0A4.64,4.64 0,0 1,139.93 219.12ZM48.65,209.78h86.32a43.4,43.4 0,0 0,-86.32 0ZM265.29,124.86L161.4,124.86a4.67,4.67 0,0 1,0 -9.34h103.89a4.67,4.67 0,0 1,0 9.34ZM265.29,153.36L161.4,153.36a4.67,4.67 0,0 1,0 -9.34h103.89a4.67,4.67 0,0 1,0 9.34ZM265.29,181.81L161.4,181.81a4.67,4.67 0,0 1,0 -9.34h103.89a4.67,4.67 0,0 1,0 9.34ZM265.29,210.26L161.4,210.26a4.67,4.67 0,0 1,0 -9.34h103.89a4.67,4.67 0,0 1,0 9.34Z" />
                                            <path
                                                fill="#eaf1fd"
                                                stroke="#eaf1fd"
                                                stroke-width="0.3"
                                                d="M180.56,61.01a4.64,4.64 0,0 1,-4.67 -4.67L175.89,36.6a14.49,14.49 0,1 0,-28.98 0L146.91,56.34a4.67,4.67 0,1 1,-9.34 0L137.57,36.6a23.83,23.83 0,1 1,47.66 0L185.23,56.34A4.67,4.67 0,0 1,180.56 61.01Z" />
                                            <path
                                                fill="#4045d4"
                                                stroke="#eaf1fd"
                                                stroke-width="0.3"
                                                d="M192.5,95.67h-62.3A13.11,13.11 0,0 1,117.11 82.58L117.11,64.72A13.11,13.11 0,0 1,130.2 51.62h62.3a13.11,13.11 0,0 1,13.1 13.1L205.6,82.58A13.08,13.08 0,0 1,192.5 95.67ZM130.2,61.01a3.76,3.76 0,0 0,-3.76 3.76L126.44,82.63a3.76,3.76 0,0 0,3.76 3.76h62.3a3.76,3.76 0,0 0,3.76 -3.76L196.25,64.77a3.76,3.76 0,0 0,-3.76 -3.76Z" />
                                            <path
                                                fill="#fff"
                                                d="M198.33,90.43L198.33,56.74L120.88,56.74L120.88,90.43Z" />
                                            <path
                                                fill="#eaf1fd"
                                                stroke="#eaf1fd"
                                                stroke-width="0.3"
                                                d="M192.5,95.67h-62.3A13.11,13.11 0,0 1,117.11 82.58L117.11,64.72A13.11,13.11 0,0 1,130.2 51.62h62.3a13.11,13.11 0,0 1,13.1 13.1L205.6,82.58A13.08,13.08 0,0 1,192.5 95.67ZM130.2,61.01a3.76,3.76 0,0 0,-3.76 3.76L126.44,82.63a3.76,3.76 0,0 0,3.76 3.76h62.3a3.76,3.76 0,0 0,3.76 -3.76L196.25,64.77a3.76,3.76 0,0 0,-3.76 -3.76Z" />
                                        </svg>

                                    </i>
                                    <h4>There are no roles at `+siteName+`. You can change the site displayed here in Settings.</h4>
                                    <a class='prefer rolesMysitePref'>My Site Preferences</a>
                                </div>`;

                    $(elementId).html("<div id='noparticipant'>" +el+ "</div>");
                }
                

            },
            error: function (jqXHR, exception) {
                let getOnCallErrMsg = '';
                getOnCallErrMsg = module.exports.getOnCallErrorMsgReturn(jqXHR,exception)
                console.log(getOnCallErrMsg);
            },
            complete: function(){
                $(".sideRoleNavLoader").hide()
                $(".sideRoleListNavLoader").hide()
            }
        });
        
    },
    /** Oncall Units Scroll Update **/
    oncallUnitsScrollUpdate: function(elementName){
        let elementId =  "#"+elementName;
        $(elementId).mCustomScrollbar("update");
    },
    /** Get Roles Records based on Oncall Units **/
    getUnitBasedRoles: function(siteId,unitName,elementName,pageNo,searchVal){
        let searchTxt = encodeURIComponent(searchVal);

        let  params = 'page='+pageNo+'&search='+searchTxt+'&siteId='+siteId+'&size='+language.locali().default_unit_based_roles_pagination+'&sortby=oncallname&unit='+unitName;

        let oncallsUrl = window._env_.ApiURL + "/onCalls/?"+params;

        $.ajax({
            url: oncallsUrl,
            type: 'GET',
            dataType: 'json',
            cache: false,
            contentType: false,
            processData: false,
            async: false,
            crossDomain: true,
            headers: {
                'authorization': storage.getuserToken()
            },
            statusCode: {
                401: function (response) {
                    console.log('Security Token Error');
                    let loginUserInfo = webEncrypt.getFromLocalStorageAndDecrypt('loginUserInfo');
                    let username = loginUserInfo[0][0];
                    storage.setSession(username)
                    module.exports.getUnitBasedRoles(siteId,unitName,elementName,pageNo,searchTxt)
                },
                500: function (response) {
                    console.log('Internal Server Error');
                }
            },
            success: function (response) {
                if(response.status == 200){
                    for (let keys in response.data) {
                        let values = response.data[keys];
                        let onCallImage = values.onCallImage.trim();
                        let onCallForegroundColor = values.onCallForegroundColor.trim();
                        let fillColor = onCallForegroundColor?onCallForegroundColor:"#fff";
                        let onCallIcon = values.onCallIcon;
                        let onCallUnit = values.onCallUnit;
    
                        let Icon;
    
                        Icon = utils.getOncallIcon(onCallIcon, fillColor, onCallImage);
    
    
                        let userLoggedIn = stropheConnection.logininfo.userJID;
                        let activeMemberId = (values.activeMemberId) ? values.activeMemberId.trim() : "";
                        let activeMemberName = values.activeMemberName.trim();
                        let isChatUser = values.isChatUser;
                        let onCallId = values.onCallId.trim();
                        let onCallName = values.onCallName.trim();
                        let siteId = values.siteId;
                        let isActive = values.isActive;
    
                        let siteDiv = "";
                        let activeMemberDiv = "";
                        let activeMemberColorName = "";
                        let pagerEl = "";
    
    
                        let activeMemberObj = module.exports.getOnCallsActiveMembObj(activeMemberName,activeMemberId,userLoggedIn);
    
                        activeMemberName        =   activeMemberObj.activeMemberName;
                        activeMemberColorName   =   activeMemberObj.activeMemberColorName;
    
                        let IconixBadgeIcon = module.exports.getOnCallsIconixBadgeIcon(activeMemberName,isChatUser);
    
                        let contentDiv = '<div class="roles-content row sideBar-body" id="role-' + onCallId + '" data-member="'+activeMemberId+'" data-chat-user="'+isChatUser+'" data-isunregister="'+values.isUnregisteredUser+'" data-isactive="'+isActive+'"><div  class="col-sm-3 col-xs-3 sideBar-avatar"><div class="avatar-icon"><div class="color-code-roles" style="background-color: '+ utils.hexToRgbA(onCallImage) +';">'+Icon+IconixBadgeIcon+'</div></div> </div><div class="col-sm-9 col-xs-9 sideBar-main contact-list-main"><div class="row"><div class="col-sm-12 col-md-12 col-xs-12 sideBar-name contact-name"><div class="contact-list-div"><span class="name-meta oncall-name" title="'+onCallName+'">' + onCallName + '</span></div></div></div>';
    
                        let siteName = utils.getSiteAbbreviation(siteId);
                    
    
                        let msg_pager_no = module.exports.getOnCallsMsgPagerNo(values);
                        let sharedDeviceMsgEl = module.exports.getOnCallsSharedDevMsgEl(values,activeMemberId,msg_pager_no,userLoggedIn)
    
                        let sharedDeviceSpanHtml;
                        sharedDeviceSpanHtml = '<span class="sharedDeviceSpanHtml">'+sharedDeviceMsgEl+pagerEl+'</span>';
                    
                        let countOfOnCallMembers = values.countOfOnCallMembers;
    
                        activeMemberDiv = module.exports.getOnCallsActiveMemberDiv(countOfOnCallMembers,isActive,activeMemberColorName,activeMemberName,sharedDeviceSpanHtml);
    
                        siteDiv = module.exports.getOnCallSiteDiv(siteName,onCallUnit);
    
                        let detailsDiv = siteDiv + activeMemberDiv +  '</div></div>';
    
                        let activeUnitEl = $('.acc__title.active').parent().find('.acc__panel');
    
                        module.exports.getUnitBasedRolesAppend(activeUnitEl,contentDiv,detailsDiv);
    
                    }
                }else{
                    let activeUnitEl = $('.acc__title.active').parent().find('.acc__panel');

                    module.exports.getUnitBasedRolesNoRecAppend(activeUnitEl);

                    module.exports.disableScrollHandler()
                }
            },
            error: function (jqXHR, exception) {
                let getOnCallErrMsg = '';
                getOnCallErrMsg = module.exports.getOnCallErrorMsgReturn(jqXHR,exception)
                console.log(getOnCallErrMsg);
            },
            complete: function(){
                $(".sideRoleNavLoader").hide()
                $(".sideRoleListNavLoader").hide()

            }
        });
    },
    getUnitBasedRolesAppend: function(activeUnitEl,contentDiv,detailsDiv){
        let oncallDivEl = contentDiv+detailsDiv;

        activeUnitEl.append(oncallDivEl)
    },
    getUnitBasedRolesNoRecAppend: function(activeUnitEl){
        let divEl = `<div class="row no-unit-rec-sideBar-body noUnitRecord" ><div class="col-sm-9 col-xs-9 sideBar-main contact-list-main"><div class="sideBar-msg site-div"><span class="name-status site-name">`+language.locali().noroles_available+`</span></div></div></div>`;

        activeUnitEl.append(divEl)

    },

    /** Scroll Move to Active Units Div **/
    scrollMoveToActiveStateDiv:function(elementName){
        let elementId =  "#"+elementName;

        let scrollableDiv = $(elementId);
        let targetDiv = $(".acc__title.active");

        let targetOffset = targetDiv.offset();

        // Get the offset of the scrollable div relative to the document
        let scrollableDivOffset = scrollableDiv.offset();

        // Calculate the position of the target element relative to the scrollable div
        let positionTop = targetOffset.top - scrollableDivOffset.top + scrollableDiv.scrollTop()-50;
        
        $(elementId).mCustomScrollbar("scrollTo",positionTop,{
            moveDragger:true,
            
        });

    },

    /** My Site Role Search Handling **/
    mySiteRoleSearchHandling: function(siteId,content){
        let activeDataType = $('.rolesFilter:visible').attr('data-type');
        let type;

        if(activeDataType == 'Roles'){
            type = 'oncallname'
        }else{
            type = 'unitname'

        }

        if (content == '') {
            if(type == 'oncallname'){
                let oncallObj = {
                    siteId      :siteId,
                    search      :'',
                    page        :1,
                    isEmpty     :1,
                    elementName :'roles',
                    type        :'',
                    unitName    :'',
                
                }
                module.exports.getOnCalls(oncallObj);

            }else{
                $('.rolesFilter').removeClass('unitfilter');
                $('.rolesFilter').removeClass('alapfilter');
                $('.rolesFilterUnitIcon').addClass('unitfilter');
                $('.rolesFilterAlphaIcon').addClass('alapfilter');
                module.exports.getOncallUnits(siteId,'roles');
            }
            
        } else {
        
            content = encodeURIComponent(content);
            let oncallObj = {
                siteId      :siteId,
                search      :content,
                page        :1,
                isEmpty     :1,
                elementName :'roles',
                type        :type,
                unitName    :'',
            
            }
            module.exports.getOnCalls(oncallObj);
        }
    },
    
    /** Global Role Search Handling **/
    globalSiteRoleSearchHandling: function(content){
        let activeDataType = $('.globalRoleFilter:visible').attr('data-type');
        let siteId = $('#globalRoleSiteId').val();

        let type;

        if(activeDataType == 'Roles'){
            type = 'oncallname'
        }else{
            type = 'unitname'

        }

        if (content == '') {
            if(type == 'oncallname'){
                let oncallObj = {
                    siteId      :siteId,
                    search      :'',
                    page        :1,
                    isEmpty     :1,
                    elementName :'globalRoleLists',
                    type        :type,
                    unitName    :'',
                
                }
                module.exports.getOnCalls(oncallObj);

            }else{

                module.exports.getOncallUnits(siteId,'globalRoleLists',type);
            }


        } else {
          if (content.length > 0){
            content = encodeURIComponent(content);
            let oncallObj = {
                siteId      :siteId,
                search      :content,
                page        :1,
                isEmpty     :1,
                elementName :'globalRoleLists',
                type        :type,
                unitName    :'',
            
            }
            module.exports.getOnCalls(oncallObj);
          }
        }
    },
    /** Function to disable the event handler **/
    disableScrollHandler:function() {
        shouldHandleScroll = false;
    },

    /** Function to enable the event handler **/
    enableScrollHandler:function() {
        shouldHandleScroll = true;
    }

}

$('.side-role .filter').click(function () {
    $('.side-role .filter-options').toggleClass("menu")
});

//action on clicking a role in roles tab
$("body").on('click', ".roles-content", function (e) {
    let activeMemberId = $(this).attr("data-member").trim();
    let chatUser = $(this).attr("data-chat-user");
    let isActive = $(this).attr("data-isactive");

    if(activeMemberId == "") {
        $("#Role-details").find(".popupcontent").text(language.locali().noone_active);
        $("#Role-details").addClass("open");
    } else if (activeMemberId == stropheConnection.logininfo.userJID) {
        $("#Role-details").find(".popupcontent").text(language.locali().you_are_active_oncall);
        $("#Role-details").addClass("open");
    } else if (activeMemberId && isActive == 0){
        $("#Role-details").find(".popupcontent").text(language.locali().noone_oncall);
        $("#Role-details").addClass("open");
    } else {
        if(chatUser == 0) {
            recentdesign.recentClickAction(activeMemberId,chatUser);
            $(".side-role").css({
                "left": "-100%"
            });
            $(".side-global-role-list").css({
                "left": "-100%"
            });

            $(".blocked-person").text("You cannot send messages to this chat.");
        } else  {
            recentdesign.recentClickAction(activeMemberId);
            $(".side-role").css({
                "left": "-100%"
            });
            $(".side-global-role-list").css({
                "left": "-100%"
            });
        }
    }
});

//action on clicking ok in a roles tab
$("#close-roles-popup").click(function() {
    $("#Role-details").removeClass("open");
});

/** shared Device Pager Icon Drop down Open**/
$("body").on('click', ".sharedDevicePagerIcon", function (e) {
    e.stopPropagation();
    $('.pager_massage').val('');
    $(".sharedDevPagerDiv").removeClass('open');
    $(".sharedDevMsgDiv").removeClass('open');

    let oncallPagerNo = $(this).attr("data-oncall_pager_no");
    let msgPagerNo = $(this).attr("data-msg_pager_no");
    let profileVisibility = webEncrypt.getFromLocalStorageAndDecrypt('settings').profileVisibility;
    let activeMemberId = $(this).attr("data-activememberid");
    let userLoggedIn = stropheConnection.logininfo.userJID;


    if(oncallPagerNo != "" && (msgPagerNo != "" && profileVisibility.pager_number && activeMemberId !== userLoggedIn)){
        let selectedRoleId = $(this).closest('.roles-content').attr('id'); 
        let firstRoleId = $(".roles-content:visible").first().attr('id'); //Role List First El
        let lastRoleId = $(".roles-content:nth-last-child(1)").attr('id'); //Role List Last El
        let selectedUlEl = $(this).parent().parent().children().last();
         if(firstRoleId != selectedRoleId && selectedRoleId == lastRoleId){
             selectedUlEl.addClass('sharedDeviceChangeUl') 
         }

        $(this).parent().parent().addClass('open')

    }else {

        $(this).parent().parent().addClass('open')

        
    }
});
function sharedDeviceMsgIconFirstAlignment(sharedDevEvent,isOpened){
    let activeMemberId = sharedDevEvent.attr("data-member").trim();
    if(activeMemberId != "" && activeMemberId != "null"){
        let selectedRoleId = sharedDevEvent.closest('.roles-content').attr('id'); 
        let firstRoleId = $(".roles-content:visible").first().attr('id'); //Role List First El
        let lastRoleId = $(".roles-content:nth-last-child(1)").attr('id'); //Role List Last El
        let selectedUlEl = sharedDevEvent.parent().parent().children().last();
        if(firstRoleId != selectedRoleId && selectedRoleId == lastRoleId){
            selectedUlEl.addClass('sharedDeviceChangeUl') 
        }
        sharedMsgIconKebabActionHandling(sharedDevEvent,isOpened)
    }else {
        sharedMsgIconKebabActionHandling(sharedDevEvent,isOpened)
    }
};
function sharedMsgIconKebabActionHandling(sharedDevEvent,isOpened){
    if(!isOpened){
        sharedDevEvent.parent().parent().addClass('open')
    }else {
        sharedDevEvent.parent().parent().removeClass('open')
    }
}
function lastElementDropdownPopupHandling(sharedDevEvent){
    let parentElId = sharedDevEvent.closest('.mCSB_container').parent().parent().attr('id')
    parentElId = '#'+parentElId;
    let selectedRoleId = sharedDevEvent.closest('.roles-content').attr('id'); 
    let firstRoleId = $(parentElId+" .roles-content:visible").first().attr('id'); //Role List First El
    let lastRoleId = $(parentElId+" .roles-content:nth-last-child(1):visible").attr('id'); //Role List Last El
    let selectedUlEl = sharedDevEvent.parent().parent().children().last();
    if(firstRoleId != selectedRoleId && selectedRoleId == lastRoleId){
        selectedUlEl.addClass('sharedDeviceChangeUl') 
    }


}
function sharedDeviceMsgIconSecondAlignment(sharedDevEvent,oncallPagerNo,msgPagerNo,profileVisibility,userLoggedIn,isOpened){
    let activeMemberId = sharedDevEvent.attr("data-member").trim();
    if(oncallPagerNo != "" || (msgPagerNo != "" && profileVisibility.pager_number && activeMemberId !== userLoggedIn)){
        
        sharedMsgIconKebabActionHandling(sharedDevEvent,isOpened)
    }else {
        if(activeMemberId == "") {
            $("#Role-details").find(".popupcontent").text(language.locali().noone_active);
            $("#Role-details").addClass("open");
        } else if (activeMemberId == stropheConnection.logininfo.userJID) {
            $("#Role-details").find(".popupcontent").text(language.locali().you_are_active_oncall);
            $("#Role-details").addClass("open");
        } else {
            sharedMsgIconKebabActionHandling(sharedDevEvent,isOpened)
        }
    }
    lastElementDropdownPopupHandling(sharedDevEvent)

}
/** shared Device Msg Icon Drop down Open**/

$("body").on('click', ".sharedDeviceMsgIcon", function (e) {
    e.stopPropagation();
    $('.pager_massage').val('');
    let isOpened = $(this).parent().parent().hasClass('open');
    if(!isOpened){
        $(".sharedDevMsgDiv").removeClass('open');
        $(".sharedDevPagerDiv").removeClass('open');
    }
    let onCallReceiveDeviceId = $(this).attr("data-oncallreceivedeviceid").trim();
    let oncallPagerNo = $(this).attr("data-oncall_pager_no");
    let msgPagerNo = $(this).attr("data-msg_pager_no");
    let profileVisibility = webEncrypt.getFromLocalStorageAndDecrypt('settings').profileVisibility;
    let userLoggedIn = stropheConnection.logininfo.userJID;
    let sharedDevEvent = $(this);
    if(onCallReceiveDeviceId != '' && typeof onCallReceiveDeviceId != "undefined"){
        sharedDeviceMsgIconFirstAlignment(sharedDevEvent,isOpened);
    }else {
        sharedDeviceMsgIconSecondAlignment(sharedDevEvent,oncallPagerNo,msgPagerNo,profileVisibility,userLoggedIn,isOpened);
    }

});

/** shared Device Ikonix Chat Click Event**/

$("body").on('click', ".sharedDeviceUserChat", function (e) {
    e.stopPropagation();
    let activeMemberId = $(this).attr("data-member").trim();
    let chatUser = $(this).attr("data-chat-user");
    if(activeMemberId == "") {
        $("#Role-details").find(".popupcontent").text(language.locali().noone_active);
        $("#Role-details").addClass("open");
    } else if (activeMemberId == stropheConnection.logininfo.userJID) {
        $("#Role-details").find(".popupcontent").text(language.locali().you_are_active_oncall);
        $("#Role-details").addClass("open");
    } else {
        if(chatUser == 0) {
            recentdesign.recentClickAction(activeMemberId,chatUser);
            $(".side-role").css({
                "left": "-100%"
            });
            $(".side-global-role-list").css({
                "left": "-100%"
            });
           
        } else  {
            recentdesign.recentClickAction(activeMemberId);
            $(".side-role").css({
                "left": "-100%"
            });
            $(".side-global-role-list").css({
                "left": "-100%"
            });
        }
    }

});

/** shared Device Message Role Pager Click Event**/

$("body").on('click', ".msg-role-pager", function (e) {
    e.stopPropagation();
    let pagerNo = $(this).data('pagerno');
    let roleName = $(this).data('name');
    let pagerNodeId = $(this).data('nodeid');
    let pagerDeviceType = $(this).data('type');
    let pagerToId = $(this).data('toid');


    $('#myModal').modal('show');
    $('.pagerHeader').html('Pager Message to '+roleName);
    $('#PagerNumberId').attr("data-id", pagerNo);
    $('#pagerNodeId').attr("data-nodeid",pagerNodeId);
    $('#pagerDeviceType').attr("data-type",pagerDeviceType);
    $('#pagerToId').attr("data-toid",pagerToId);
    $("#isReceivedDevice").attr('data-isreceiveddevice',0);

    $(".sharedDevPagerDiv").removeClass('open');
    $(".sharedDevMsgDiv").removeClass('open');
    let pagerSettings = webEncrypt.getFromLocalStorageAndDecrypt('settings');
    $('.pager_length').text(pagerSettings.pagerMaxCharLimit);
    $('.pager_massage').attr('maxLength',pagerSettings.pagerMaxCharLimit).attr('minLength',pagerSettings.pagerMinCharLimit)
});

/** shared Device Message Pager Click Event**/

$("body").on('click', ".msg-pager", function (e) {
    e.stopPropagation();
    let pagerNo = $(this).data('pagerno');
    let name = $(this).data('name');
    let nodeId = $(this).data('nodeid');
    let pagerDeviceType = $(this).data('type');
    let pagerToId = $(this).data('toid');


    $('#myModal').modal('show');
    $('.pagerHeader').html('Pager Message to '+name);
    $('#PagerNumberId').attr("data-id", pagerNo);
    $('#pagerNodeId').attr("data-nodeid",nodeId);
    $('#pagerDeviceType').attr("data-type",pagerDeviceType);
    $('#pagerToId').attr("data-toid",pagerToId);

    $("#isReceivedDevice").attr('data-isreceiveddevice',0);


    $(".sharedDevPagerDiv").removeClass('open');
    $(".sharedDevMsgDiv").removeClass('open');
    let settings = webEncrypt.getFromLocalStorageAndDecrypt('settings');
    $('.pager_length').text(settings.pagerMaxCharLimit);
    $('.pager_massage').attr('maxLength',settings.pagerMaxCharLimit).attr('minLength',settings.pagerMinCharLimit)

});

/** shared Device Received Device Click Event**/

$("body").on('click', ".msg-received-device-pager", function (e) {
    e.stopPropagation();
    let pagerNo = $(this).data('pagerno');
    let deviceName = $(this).attr('data-deviceName');
    let nodeId = $(this).attr("data-nodeid");
    let pagerDeviceType = $(this).attr("data-type");
    let pagerToId = $(this).attr("data-toid");


    $('#myModal').modal('show');
    $('.pagerHeader').html('Message '+deviceName)
    $('#PagerNumberId').attr("data-id", pagerNo);
    $('#pagerNodeId').attr("data-nodeid",nodeId);
    $('#pagerDeviceType').attr("data-type",pagerDeviceType);
    $('#pagerToId').attr("data-toid",pagerToId);
    $("#isReceivedDevice").attr('data-isreceiveddevice',1);

    $(".sharedDevPagerDiv").removeClass('open');
    $(".sharedDevMsgDiv").removeClass('open');
    let settings = webEncrypt.getFromLocalStorageAndDecrypt('settings');
    $('.pager_length').text(settings.receiveDeviceMessageLength);
    $('.pager_massage').attr('maxLength',settings.receiveDeviceMessageLength).attr('minLength',settings.receiveDeviceMessageLength)

});

/** Oncall Shared Device ul Element Hover Event**/
$(document).on({
    mouseenter: function() {
        $('.roles-content').css('background','#fff')
    },
    mouseleave: function() {
        $('.roles-content').css('background','')
    }
}, '.sharedDeviceUlEl');

/** Oncall Pager ul Element Hover Event**/
$(document).on({
    mouseenter: function() {
        $('.roles-content').css('background','#fff')
    },
    mouseleave: function() {
        $('.roles-content').css('background','')
    }
}, '.pagerDeviceUlEl');


$("body").on('click', "#scrollBottomClick", function (e) {
    let bottom = $('.acc__title.active').parent().find('.acc__panel').children().last().position();
    $('#roles').mCustomScrollbar("scrollTo",bottom.top,{
        moveDragger:true,
        
    });
});
/** Roles Organization Feature Click Events Start**/

$("body").on('click', ".acc__title", function (j) {
    let dropDown = $(this).closest('.acc__card').find('.acc__panel');
    $(this).closest('.acc').find('.acc__panel').not(dropDown).slideUp();

    let sideBarIdName = $(this).parent().parent().parent().parent().parent().parent().attr('id');
    
    if ($(this).hasClass('active')) {
        $(this).removeClass('active');
    } else {
        $('.acc__title.active').parent('.acc__card').find('.acc__panel').hide()
        $('.acc__title.active').removeClass('active')
        $(this).addClass('active');
        let siteId;
        let unitName = $(this).text();
        let pageNo = 1;
        let searchVal;
        let locationId = webEncrypt.getFromLocalStorageAndDecrypt('locationId');        
        if(sideBarIdName == 'globalRoleLists'){
            searchVal = $('#globalRoleSearchTxt').val()
            siteId = $('#globalRoleSiteId').val();
        }else {
            searchVal = $('#rolesText').val();
            if(locationId != null && typeof locationId != "undefined"){
                siteId = locationId.mysite_role;
            }else {
                siteId = $('#siteDetails').text();
            }
        }
        
        module.exports.enableScrollHandler();

        $(this).parent().find('.acc__panel').children().remove() // Remove All Children Element with in the Unit div

        module.exports.getUnitBasedRoles(siteId,unitName,sideBarIdName,pageNo,searchVal);
        module.exports.oncallUnitsScrollUpdate(sideBarIdName);

    }

    let thisVal = $(this);
    
    dropDown.stop(false, true).slideToggle();
    j.preventDefault();
    $(".sideRoleNavLoader").show()

    setTimeout(function () {
        module.exports.oncallUnitsScrollUpdate(sideBarIdName);
        $(".sideRoleNavLoader").hide()
        setTimeout(function () {

            if ((thisVal.hasClass('active'))) {
                module.exports.scrollMoveToActiveStateDiv(sideBarIdName)
            }
        }, 100);

    }, 500);

});

$("body").on('click', ".RolesSort", function (e) {
    if($(this).hasClass('active')){
        $('.roleFilterPopup').hide()

        return
    }
    $('.rolesFilter').removeClass('unitfilter');
    $('.rolesFilter').removeClass('alapfilter');
    $(".sideRoleNavLoader").show()

    let siteId;
    let type;
    let searchVal;
    let locationId = webEncrypt.getFromLocalStorageAndDecrypt('locationId');   
    searchVal = $('#rolesText').val()     
    if(locationId != null && typeof locationId != "undefined"){
      siteId = locationId.mysite_role;
    }else {
      siteId = $('#siteDetails').text();
    }

    if($(this).attr('data-type') == 'Roles'){
        type = 'oncallname'
        $('.rolesFilterAlphaIcon').addClass('unitfilter');
        $('.rolesFilterUnitIcon').addClass('alapfilter');
      
        setTimeout(function () {
            let oncallObj = {
                siteId      :siteId,
                search      :searchVal,
                page        :1,
                isEmpty     :1,
                elementName :'roles',
                type        :type,
                unitName    :'',
            
            }
            module.exports.getOnCalls(oncallObj);
        }, 500);

    }else {
        type = 'unitname'

        $('.rolesFilterUnitIcon').addClass('unitfilter');
        $('.rolesFilterAlphaIcon').addClass('alapfilter');
        setTimeout(function () {
            if(searchVal == ''){
                module.exports.getOncallUnits(siteId,'roles');
            }else {
                let oncallObj = {
                    siteId      :siteId,
                    search      :searchVal,
                    page        :1,
                    isEmpty     :1,
                    elementName :'roles',
                    type        :type,
                    unitName    :'',
                
                }
                module.exports.getOnCalls(oncallObj);
            }
        }, 500);

    }
    $('.roleFilterPopup').hide()

});



$("body").on('click', ".rolesFilter", function (e) {
    e.stopPropagation();
    let isToggleDivVisible = false;
    if($('.roleFilterPopup:visible').length > 0) {
        $('.roleFilterPopup').hide()
    }else {
    isToggleDivVisible = true;

        if($(this).attr('data-type') == 'Roles'){
            $('.RolesSortUnit').removeClass('active')
            $('.RolesSortAlpha').addClass('active')

        }else {
            $('.RolesSortUnit').addClass('active')
            $('.RolesSortAlpha').removeClass('active')
        }
        $('.roleFilterPopup').show()
    }
    $(document).click(function(event) {
        event.stopPropagation()

        if (isToggleDivVisible && !$(event.target).closest('.roleFilterPopup, .rolesFilter').length) {
          $('.roleFilterPopup').hide();
          isToggleDivVisible = false;
        }
      });
    

});

$("body").on('click', ".globalRoleFilter", function (e) {
    e.stopPropagation()
    let isToggleDivVisible = false;

    if($('.globalRoleFilterPopup:visible').length > 0) {
        $('.globalRoleFilterPopup').hide()
    }else {
        isToggleDivVisible = true;

        if($(this).attr('data-type') == 'Roles'){
            $('.globalRolesSortUnit').removeClass('active')
            $('.globalRolesSortAlpha').addClass('active')

        }else {
            $('.globalRolesSortUnit').addClass('active')
            $('.globalRolesSortAlpha').removeClass('active')
        }
        $('.globalRoleFilterPopup').show()
    }

    $(document).click(function(event) {
        event.stopPropagation()
        if (isToggleDivVisible && !$(event.target).closest('.globalRoleFilterPopup, .globalRoleFilter').length) {
          $('.globalRoleFilterPopup').hide();
        }
      });

});

$("body").on('click', ".globalRolesSort", function (e) {
    if($(this).hasClass('active')){
        $('.globalRoleFilterPopup').hide()
        return
    }

    $('.globalRoleFilter').removeClass('unitfilter');
    $('.globalRoleFilter').removeClass('alapfilter');
    $(".sideRoleListNavLoader").show()

    let siteId;
    let type;
    let searchVal;
    searchVal = $('#globalRoleSearchTxt').val()     
    siteId = $('#globalRoleSiteId').val();

    if($(this).attr('data-type') == 'Roles'){
        type = 'oncallname'

        $('.globalRoleFilterAlphaIcon').addClass('unitfilter');
        $('.globalRoleFilterUnitIcon').addClass('alapfilter');
        
        setTimeout(function () {
            let oncallObj = {
                siteId      :siteId,
                search      :searchVal,
                page        :1,
                isEmpty     :1,
                elementName :'globalRoleLists',
                type        :type,
                unitName    :'',
            
            }
            module.exports.getOnCalls(oncallObj); // Get & apped Oncalls Based On Site Id

        }, 500);

    }else {
        type = 'unitname'

        $('.globalRoleFilterUnitIcon').addClass('unitfilter');
        $('.globalRoleFilterAlphaIcon').addClass('alapfilter');
        setTimeout(function () {
            if(searchVal == ''){
                module.exports.getOncallUnits(siteId,'globalRoleLists');

            }else {
                let oncallObj = {
                    siteId      :siteId,
                    search      :searchVal,
                    page        :1,
                    isEmpty     :1,
                    elementName :'globalRoleLists',
                    type        :type,
                    unitName    :'',
                
                }
                module.exports.getOnCalls(oncallObj); // Get & apped Oncalls Based On Site Id

            }
        }, 500);

    }
    $('.globalRoleFilterPopup').hide()

});

/** Roles Organization Feature Click Events End**/

$("body").on('click', ".rolesMysitePref", function (e) {
    $(".locationid-list-sidenav").css({
        "display": "block",
        "left": "0px"
    });

    webEncrypt.encryptAndStoreInLocalStorage('isSetRoleSitePreference', 1);
    
});

